<template>
  <div>
    <b-card no-body class="rounded-xl border-none">
      <div class="mt-4 flex w-full items-end">
        <div class="w-1/2 pr-4">
          <b-form-radio
            v-model="selected"
            class="custom-control-inline font-semibold radio-btn-fix"
            name="some-radios"
            value="A"
            >Month</b-form-radio
          >

          <select class="form-control mt-3">
            <option disabled="true">Select Month</option>
            <option>November 2021</option>
          </select>
        </div>

        <div class="w-1/2 pr-4">
          <b-form-radio
            v-model="selected"
            class="custom-control-inline font-semibold radio-btn-fix"
            name="some-radios"
            value="A"
            >Date From To</b-form-radio
          >

          <base-input class="div-mb-0">
            <flat-picker
              placeholder="Select Date...."
              slot-scope="{ focus, blur }"
              @on-open="focus"
              @on-close="blur"
              :config="{ allowInput: true }"
              class="form-control datepicker mt-3"
            >
            </flat-picker>
          </base-input>
        </div>
        <div class="w-1/2 pr-4">
          <base-input class="div-mb-0">
            <flat-picker
              placeholder="Select Date...."
              slot-scope="{ focus, blur }"
              @on-open="focus"
              @on-close="blur"
              :config="{ allowInput: true }"
              class="form-control datepicker mt-3"
            >
            </flat-picker>
          </base-input>
        </div>
        <div class="w-1/2 pl-12">
          <base-button
            filled
            type="success"
            class="px-10 py-3"
            @click="toggleDetails(true)"
            >Search</base-button
          >
        </div>
      </div>

      <div class="mt-8">
        <b-input-group>
          <b-form-input
            class="border-none shadow-lg"
            type="text"
            min="0.00"
            placeholder="Enter Search...."
          ></b-form-input>

          <b-input-group-append>
            <b-button
              variant="white"
              class="flex items-center shadow-lg"
              aria-label="search"
            >
              <feather-icon
                class="cursor-pointer mr-2"
                icon="SearchIcon"
                svgClasses="w-4 h-4"
              ></feather-icon>
            </b-button>
          </b-input-group-append>
        </b-input-group>
        <el-table
          class="table-responsive table-flush mt-6"
          header-row-class-name="thead-light table-th-color"
          :data="SummaryData"
        >
          <el-table-column label="Type" min-width="100px" prop="type" sortable>
            <template v-slot="{ row }">
              <span class="text-black font-medium">{{ row.type }}</span>
            </template>
          </el-table-column>

          <el-table-column
            label="Campaign ID"
            min-width="150px"
            prop="campaignid"
            sortable
          >
            <template v-slot="{ row }">
              <span class="text-black font-medium">{{ row.campaignid }}</span>
            </template>
          </el-table-column>

          <el-table-column label="Date" min-width="150px" prop="Date" sortable>
            <template v-slot="{ row }">
              <span class="text-black font-medium">{{ row.Date }}</span>
            </template>
          </el-table-column>

          <el-table-column
            label="	Total Number"
            min-width="140px"
            prop="TotalNumber"
            sortable
          >
            <template v-slot="{ row }">
              <span class="text-black font-medium">{{ row.TotalNumber }}</span>
            </template>
          </el-table-column>

          <el-table-column
            label="Total Delivered"
            min-width="180px"
            prop="TotalDelivered"
            sortable
          >
            <template v-slot="{ row }">
              <span class="text-black font-medium">{{
                row.TotalDelivered
              }}</span>
            </template>
          </el-table-column>

          <el-table-column
            label="Total DND"
            min-width="140px"
            prop="TotalDND"
            sortable
          >
            <template v-slot="{ row }">
              <span class="text-black font-medium">{{ row.TotalDND }}</span>
            </template>
          </el-table-column>

          <el-table-column
            label="Total Optout"
            min-width="140px"
            prop="TotalOptout"
            sortable
          >
            <template v-slot="{ row }">
              <span class="text-black font-medium">{{ row.TotalOptout }}</span>
            </template>
          </el-table-column>

          <el-table-column
            label="Total Failed"
            min-width="140px"
            prop="TotalFailed"
            sortable
          >
            <template v-slot="{ row }">
              <span class="text-black font-medium">{{ row.TotalFailed }}</span>
            </template>
          </el-table-column>
        </el-table>

        <b-card-footer class="py-4 d-flex justify-content-end">
          <base-pagination
            v-model="currentPage"
            :per-page="10"
            :total="50"
          ></base-pagination>
        </b-card-footer>
      </div>
    </b-card>
  </div>
</template>
<script>
import SummaryData from "./SummaryData";

import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
} from "element-ui";
export default {
  name: "light-table",
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    flatPicker,
  },
  data() {
    return {
      SummaryData,
      currentPage: 1,
      isDetailsActive: false,
      isShowCreate: false,
    };
  },
  methods: {
    toggleDetails(val = false) {
      this.isDetailsActive = val;
    },
  },
};
</script>
